<script lang="ts">
    import { page } from '$app/stores';
    import { NextPageNavigator } from '$lib/global/helper/NextPageNavigator';
    import { trackButtonClick } from '$lib/global/tracking/v3';
    import { getCookiePreferences } from '$lib/helper';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';
    import { advancedLinking } from '$lib/Stores/stores';
    import { getLinkingPreloadTarget, handleLinkingNavigation } from '$lib/utils/linkingNavigation';
    import { getAllUserAnswers } from '$lib/utils/userAnswerStorage';

    import get from 'lodash/get';

    import WebinarView from './Webinar.View.svelte';
    import MediaOverlay from '../../ConsentOverlay/MediaOverlay/MediaOverlay.svelte';

    import type { WebinarContent } from '$lib/types/Components/Webinar/WebinarContent';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let id: string;
    export let theme: Theme;
    export let content: WebinarContent;
    export let campaignId: string;
    export let campaignVersionId: string;
    export let cookiesEnabled = false;
    export let nextPage = '';
    export let firstResultPage = '';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let language: Language = 'en';

    const {
        data: { pageIdSlugMap },
    } = $page;

    // Navigation
    const externalLink = content.linking.url;
    const nextPageNavigator = new NextPageNavigator(campaignId, firstResultPage, pageIdSlugMap);
    const originalLogicNextPage = get(content, 'linking.pageId', nextPage);
    const linkingComponentId = get(content, 'linking.componentId');
    const isExternal = !content.linking.isInternal && !!externalLink;
    const isNewTab = get(content, 'linking.isNewTab', false);

    const cookies = getCookiePreferences(campaignId, campaignVersionId);

    const handleBtnClick = () => {
        // Tracking
        trackButtonClick(id);

        return handleLinkingNavigation({
            componentId: id,
            userAnswers: getAllUserAnswers(campaignVersionId),
            advancedLinking: $advancedLinking,
            nextPageNavigator,
            originalLogicNextPage,
            nextPage,
            externalLink,
            isExternal,
            isNewTab,
            currentPageId: $page.data.pageId,
            linkingComponentId,
        });
    };

    const handleBtnMouseEnter = () => {
        const { pageId, isExternal: isExternalTarget } = getLinkingPreloadTarget({
            componentId: id,
            userAnswers: getAllUserAnswers(campaignVersionId),
            advancedLinking: $advancedLinking,
            nextPageNavigator,
            originalLogicNextPage,
            nextPage,
            isExternal,
        });

        nextPageNavigator.preload(pageId, isExternalTarget);
    };

    $: acceptedMediaOverlay = cookies.Media || $mediaCookiesAccepted;
</script>

{#if cookiesEnabled && !acceptedMediaOverlay}
    <MediaOverlay {id} {campaignId} {campaignVersionId} {language} />
{:else}
    <WebinarView
        {id}
        url={content.video}
        durationTrigger={content.duration}
        message={content.placeholderText}
        btnText={content.text}
        onBtnClick={handleBtnClick}
        onBtnMouseEnter={handleBtnMouseEnter}
        box={content.box}
        {theme}
        backgroundColor={content.backgroundColor}
        color={get(content, 'color', '')}
        {transitionDelay}
        {transitionEffect}
    />
{/if}
